import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMyMapsState } from "./interfaces";
import { DEFAULT_MYMAPS } from "./constants";

const mymapsSlice = createSlice({
	name: "mymaps",
	initialState: DEFAULT_MYMAPS,
	reducers: {
		mymapsClearData: (state: IMyMapsState) => {
			Object.assign(state, DEFAULT_MYMAPS);
		},
		mymapsSetFoldersData: (state: IMyMapsState, action: PayloadAction<Pick<IMyMapsState, "rootId" | "hasFolders" | "alwaysOnMapFoldersCount" | "alwaysOnMapItemsCount">>) => {
			state.rootId = action.payload.rootId;
			state.hasFolders = action.payload.hasFolders;
			state.alwaysOnMapFoldersCount = action.payload.alwaysOnMapFoldersCount;
			state.alwaysOnMapItemsCount = action.payload.alwaysOnMapItemsCount;
		},
		mymapsSetAlwaysOnMapFoldersCount: (state: IMyMapsState, action: PayloadAction<Pick<IMyMapsState, "alwaysOnMapFoldersCount">>) => {
			state.alwaysOnMapFoldersCount = action.payload.alwaysOnMapFoldersCount;
		},
		mymapsSetHasFolders: (state: IMyMapsState) => {
			state.hasFolders = true;
		},
		mymapsSetOpenedFolder: (state: IMyMapsState, action: PayloadAction<string>) => {
			state.openedFolderId = action.payload;
		},
	},
});

export const { mymapsClearData, mymapsSetFoldersData, mymapsSetAlwaysOnMapFoldersCount, mymapsSetHasFolders, mymapsSetOpenedFolder } = mymapsSlice.actions;
export default mymapsSlice.reducer;
